module.exports = __webpack_public_path__ + "img/stamp.c9eaf922.png";